import { Select, Space, Typography } from 'antd'
import { useHistogramConfiguration } from 'features/drilldown/components/histogram/contexts/HistogramConfigurationContext'
import { PlotlyOrientation } from 'features/drilldown/components/histogram/plotlyGenerators'
import { FC } from 'react'

const { Text } = Typography

const ORIENTATION_OPTIONS: Array<{
  value: PlotlyOrientation
  label: string
}> = [
  { value: 'h', label: 'Horizontal' },
  { value: 'v', label: 'Vertical' },
]

export const HistoPlotConfigView: FC = () => {
  const { orientation, setOrientation, plotType, setPlotType } =
    useHistogramConfiguration()

  const isPlotConfigurable = !!setOrientation || !!setPlotType
  return (
    <>
      {isPlotConfigurable && (
        <Space orientation='vertical' size='small' style={{ width: '100%' }}>
          {!!setPlotType && (
            <Space align='center' size='small'>
              <Text strong>Plot:</Text>
              <Select
                options={[
                  { value: 'bar', label: 'Bar' },
                  { value: 'pie', label: 'Pie' },
                  { value: 'stacked', label: 'Stacked' },
                ]}
                value={plotType}
                onChange={setPlotType}
                style={{ width: 200 }}
              />
            </Space>
          )}
          {!!setOrientation && (
            <Space align='center' size='small'>
              <Text strong>Orientation:</Text>
              <Select
                options={ORIENTATION_OPTIONS}
                value={orientation}
                onChange={setOrientation}
                style={{ width: 200 }}
              />
            </Space>
          )}
        </Space>
      )}
    </>
  )
}
